var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c("div", { staticClass: "formTitle" }, [_vm._v("新增导航")]),
      _vm._v(" "),
      _c("form-icon", {
        attrs: { "form-data": _vm.formData },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }